import React from "react";
import { Input, Form, InputNumber } from "antd";

const FormFields = () => {
  return (
    <>
      <Form.Item name="productCode" label="Code Produit">
        <Input placeholder="Code (ex: dh12345)" />
      </Form.Item>
      
      <Form.Item name="family" label="Famille">
        <Input placeholder="Famille (ex: dh, nov...)" />
      </Form.Item>
      
      <Form.Item name="barCode" label="Code Barre">
        <Input placeholder="Code Barre" />
      </Form.Item>
      <Form.Item
        name="name"
        label="Nom de Produit"
        rules={[
          {
            required: true,
            message: "S'il vous plaît entrer le nom du produit",
          },
        ]}
      >
        <Input placeholder="Nom de produit" />
      </Form.Item>
      <Form.Item
        name="price"
        label="Prix"
        rules={[
          {
            required: true,
            message: "S'il vous plaît entrer le prix de produit",
          },
          {
            type: 'number',
            message: "Le prix doit être un nombre valide",
          },
        ]}
      >
        <InputNumber
          placeholder="Prix de produit"
          style={{ width: '100%' }}
          min={0}
        />
      </Form.Item>
    </>
  );
};

export default FormFields;
